import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSettings = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M6 5H4C3.44772 5 3 5.44772 3 6V9C3 9.55228 3.44772 10 4 10H6C6.55228 10 7 9.55228 7 9V6C7 5.44772 6.55228 5 6 5Z",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 3V5V3ZM5 10V19Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 10V19M5 3V5V3Z",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 13H10C9.44772 13 9 13.4477 9 14V17C9 17.5523 9.44772 18 10 18H12C12.5523 18 13 17.5523 13 17V14C13 13.4477 12.5523 13 12 13Z",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 3V13V3ZM11 18V19Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 18V19M11 3V13V3Z",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18 4H16C15.4477 4 15 4.44772 15 5V9C15 9.55228 15.4477 10 16 10H18C18.5523 10 19 9.55228 19 9V5C19 4.44772 18.5523 4 18 4Z",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17 3V4V3ZM17 10V19Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17 10V19M17 3V4V3Z",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgSettings);
export { ForwardRef as ReactComponent };
